"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = VideoThumbnail;

var _immutable = _interopRequireDefault(require("immutable"));

var _ActionTypes = _interopRequireDefault(require("FileManagerCore/actions/ActionTypes"));

var _Constants = require("FileManagerCore/Constants");

var defaultState = _immutable.default.Map({
  updateThumbnailRequestStatus: _Constants.RequestStatus.UNINITIALIZED,
  generateAndUpdateThumbnailRequestStatus: _Constants.RequestStatus.UNINITIALIZED
});

function VideoThumbnail() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type;

  switch (type) {
    case _ActionTypes.default.VIDEO_THUMBNAIL_UPDATE_ATTEMPTED:
      return state.set('updateThumbnailRequestStatus', _Constants.RequestStatus.PENDING);

    case _ActionTypes.default.VIDEO_THUMBNAIL_UPDATE_FAILED:
      return state.set('updateThumbnailRequestStatus', _Constants.RequestStatus.FAILED);

    case _ActionTypes.default.VIDEO_THUMBNAIL_UPDATE_SUCCEEDED:
      return state.set('updateThumbnailRequestStatus', _Constants.RequestStatus.SUCCEEDED);

    case _ActionTypes.default.GENERATE_AND_UPDATE_VIDEO_THUMBNAIL_ATTEMPTED:
      return state.set('generateAndUpdateThumbnailRequestStatus', _Constants.RequestStatus.PENDING);

    case _ActionTypes.default.GENERATE_AND_UPDATE_VIDEO_THUMBNAIL_FAILED:
      return state.set('generateAndUpdateThumbnailRequestStatus', _Constants.RequestStatus.FAILED);

    case _ActionTypes.default.GENERATE_AND_UPDATE_VIDEO_THUMBNAIL_SUCCEEDED:
      return state.set('generateAndUpdateThumbnailRequestStatus', _Constants.RequestStatus.SUCCEEDED);

    default:
      return state;
  }
}

module.exports = exports.default;